import React from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../components/Button/PrimaryButton';
import { FullTextLogo } from '../../components/CompanyLogo';
import PaymentSuccessIcon from '../../components/Icons/PaymentSuccessIcon';
import { ExternalLink } from '../../components/Link/Link';
import LogoHeader from '../../components/LogoHeader/LogoHeader';

const PaymentSuccess = () => {
  return (
    <Container>
      <LogoHeader />
      <LogoArea>
        <FullTextLogo className="header" />
      </LogoArea>
      <MessageBox>
        <PaymentSuccessIcon />
        <H1>Your payment was successful</H1>
        <P>
          You can track the progress of your package. Your package should be
          delivered soon. <br />
          We have sent you detailed information to your email, with your
          receipt, Package ID and the link to the webpage that tracks your
          package.
        </P>
        <ExternalLink to="https://darum-cp.web.app/">
          <PrimaryButton arrowIcon>Track your Package</PrimaryButton>
        </ExternalLink>
      </MessageBox>
    </Container>
  );
};

export default PaymentSuccess;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const LogoArea = styled.div`
  display: none;

  @media (max-width: 480px) {
    display: flex;
    justify-content: center;
    margin-top: 3.03rem;
  }
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.foundationBlackB30};
  padding: 3.31rem 4rem;
  width: 60%;
  margin: auto;
  margin-top: 6.19rem;
  gap: 2rem;

  @media (max-width: 480px) {
    width: 100%;
    border: none;
    padding: 2rem 1.63rem;
    margin-top: 5rem;
  }
`;

const H1 = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: #000;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const P = styled.p`
  font-size: 1.25rem;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;
